"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTeamsFx = void 0;
const teamsfx_1 = require("@microsoft/teamsfx");
const msteams_react_base_component_1 = require("msteams-react-base-component");
const useData_1 = require("./useData");
/**
 * Initialize TeamsFx SDK with customized configuration.
 *
 * @param teamsfxConfig - custom configuration to override default ones.
 * @returns TeamsFxContext object
 *
 * @beta
 */
function useTeamsFx(teamsfxConfig) {
    const [result] = (0, msteams_react_base_component_1.useTeams)({});
    const { data, error, loading } = (0, useData_1.useData)(async () => {
        if (process.env.NODE_ENV === "development") {
            (0, teamsfx_1.setLogLevel)(teamsfx_1.LogLevel.Verbose);
            (0, teamsfx_1.setLogFunction)((level, message) => {
                console.log(message);
            });
        }
        return new teamsfx_1.TeamsFx(teamsfx_1.IdentityType.User, teamsfxConfig);
    });
    return Object.assign({ teamsfx: data, error, loading }, result);
}
exports.useTeamsFx = useTeamsFx;
